import { TLanguages } from "~/lang/types/languages"

export const languages: TLanguages = {
  fa: "Persian",
  en: "English",
  dashboards: "Dashboard",
  basicInformation: "Basic Information",
  cargoOwnerManagement: "Cargo Owner Management",
  cargoManagement: "Cargo Management",
  driverManagement: "Driver Management",
  shippingManagement: "Shipping Management",
  loadsManagement: "Loads management",
  bol: "BOL",
  otpManagement: "OTP Management",
  loadingManagement: "Loading Management",
  users: "Users",
  contractManagement: {
    title: "Hangouts",
    subHangouts: {
      cargoOwner: "Cargo Owner Contract",
      bolCompany: "Company Contract",
    },
  },
  financialManagement: {
    title: "Hangouts",
    subHangouts: {
      withdrawal: "Withdrawal",
      freightFinancialReport: "Freight Financial Report",
    },
  },
  financial: "Financial",
  reports: "Reports",
  profile: "Profile",
  settings: "Settings",
  logout: "Log out",
  description: "Description",
  fullscreen: "FullScreen",
  exitFullscreen: "Exit FullScreen",

  phoneNumber: "phoneNumber",
  brand: "brand",
  billOfLading: "bill of lading",
  smartDriverCode: "smart driver code",
  model: "model",
  constructionYear: "construction year",
  licenceNumber: "licence number",
  nationalCode: "national code",
  smartNumber: "smart number",
  remittanceIssuance: "Remittance issuance",
}
